<template>
  <div
    v-if="showUsage"
    class="workflow-history-usage"
    :title="$t('workflowHistoryUsage.title')"
  >
    <Badge color="neutral" rounded size="small">
      {{
        $t('workflowHistoryUsage.usage', {
          count: usage,
        })
      }}
    </Badge>
  </div>
</template>

<script>
export default {
  name: 'WorkflowHistoryUsage',
  props: {
    workflowHistory: {
      type: Object,
      required: true,
    },
  },
  computed: {
    usage() {
      return this.workflowHistory.plugin_data?.saas?.usage ?? null
    },
    showUsage() {
      return this.workflowHistory.status !== 'started' && this.usage !== null
    },
  },
}
</script>
